/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Fitting } from "./fitting"

export interface SystemDef {
    name: string
    unit: string
    id: string
    systemShape: string
    systemUniqueId: string
    hangerDisabledFor: string
    isClearence: string
    fittings: Fitting[]
    InVisibility?: string
    IsHangerNeeded?: string
  }